// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__1GnUY","info":"Note_info__30rAn","note":"Note_note__3RNWt","actions":"Note_actions__uKwG4"};